export default __webpack_public_path__ + "static/media/01_action_green_800.a2cf4921.gif";